import React from 'react';
import SVGLoader from './SVGLoader';

const ArchiveIcon = props => {
  const {
    width = 16,
    height = 16,
    viewboxWidth = 16,
    viewboxHeight = 16,
  } = props;

  return (
    <SVGLoader
      {...props}
      width={width}
      height={height}
      viewboxWidth={viewboxWidth}
      viewboxHeight={viewboxHeight}
    >
      <g clipPath="url(#clip0_152_2344)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1 0.666672H15C15.5333 0.666672 16 1.13334 16 1.66667V3.50001C16 3.67682 15.9298 3.84639 15.8047 3.97141C15.6797 4.09643 15.5101 4.16667 15.3333 4.16667H0.666667C0.489856 4.16667 0.320286 4.09643 0.195262 3.97141C0.0702379 3.84639 0 3.67682 0 3.50001V1.66667C0 1.13334 0.466667 0.666672 1 0.666672ZM1.46667 5.33334C1.33406 5.33334 1.20688 5.38602 1.11311 5.47979C1.01935 5.57355 0.966667 5.70073 0.966667 5.83334V12.8333C0.966667 14.2427 2.05733 15.3333 3.46667 15.3333H12.5333C13.9427 15.3333 15.0333 14.2427 15.0333 12.8333V5.83334C15.0333 5.70073 14.9807 5.57355 14.8869 5.47979C14.7931 5.38602 14.6659 5.33334 14.5333 5.33334H1.46667ZM10.6087 8.63467C10.6701 8.57225 10.7187 8.49833 10.7516 8.41715C10.7845 8.33596 10.8011 8.24908 10.8004 8.16149C10.7997 8.07389 10.7818 7.98729 10.7476 7.90662C10.7135 7.82595 10.6638 7.7528 10.6013 7.69134C10.5389 7.62988 10.465 7.58132 10.3838 7.54843C10.3026 7.51553 10.2157 7.49895 10.1281 7.49963C10.0406 7.50032 9.95395 7.51824 9.87328 7.55239C9.79261 7.58655 9.71946 7.63625 9.658 7.69867L8 9.38334L6.342 7.69867C6.21788 7.57261 6.04876 7.50101 5.87185 7.49963C5.69494 7.49826 5.52473 7.56722 5.39867 7.69134C5.2726 7.81546 5.201 7.98458 5.19963 8.16149C5.19825 8.3384 5.26721 8.50861 5.39133 8.63467L7.06467 10.3333L5.39133 12.032C5.26721 12.1581 5.19825 12.3283 5.19963 12.5052C5.201 12.6821 5.2726 12.8512 5.39867 12.9753C5.52473 13.0995 5.69494 13.1684 5.87185 13.167C6.04876 13.1657 6.21788 13.0941 6.342 12.968L8 11.2833L9.658 12.968C9.78212 13.0941 9.95124 13.1657 10.1281 13.167C10.3051 13.1684 10.4753 13.0995 10.6013 12.9753C10.7274 12.8512 10.799 12.6821 10.8004 12.5052C10.8017 12.3283 10.7328 12.1581 10.6087 12.032L8.93533 10.3333L10.6087 8.63467Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_152_2344">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </SVGLoader>
  );
};

export default ArchiveIcon;
